(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/transcript-file/assets/javascripts/process-transcript-data.js') >= 0) return;  svs.modules.push('/components/accountservices/transcript-file/assets/javascripts/process-transcript-data.js');

'use strict';

if (typeof exports === 'object') {
  const trinidad = require('trinidad-core').core;
  module.exports = getApi(trinidad.components.require('libs', 'date-fns').api);
} else {
  svs.accountservices.transcript_file.processData = getApi(dateFns);
}
function getApi(dateFns) {
  const transcriptBase = [{
    OrderId: null,
    OrderType: '1',
    OrderStatus: null
  }, {
    OrderId: null,
    OrderType: '2',
    OrderStatus: null
  }, {
    OrderId: null,
    OrderType: '3',
    OrderStatus: null
  }];
  function MixValues(includes, data, downloadUrlBase) {
    const orderArray = data.getOrderCustomerTranscriptStatusReplyObject.ordersstatus;
    return replaceResult(includes, orderArray, downloadUrlBase);
  }
  function fixTranscriptObjects(resultArray, downloadUrlBase) {
    let transcriptObject = {};
    const fixedTranscripts = [];
    for (let i = 0; i < resultArray.length; i++) {
      if (resultArray[i].OrderStatus === 'NOTREADY' || resultArray[i].OrderStatus === 'READY') {
        transcriptObject.orderTime = dateFns.format(new Date(resultArray[i].OrderDate), 'HH:mm');
        transcriptObject.orderDate = dateFns.format(new Date(resultArray[i].OrderDate), 'yyyy-MM-dd');
        if (resultArray[i].OrderStatus === 'READY') {
          transcriptObject.downloadUrl = "".concat(downloadUrlBase, "/minc-proxy/v1/transcript/").concat(resultArray[i].OrderId);
        }
      }
      transcriptObject.orderId = resultArray[i].OrderId;
      transcriptObject.orderType = resultArray[i].OrderType;
      transcriptObject.orderStatus = resultArray[i].OrderStatus;
      fixedTranscripts.push(transcriptObject);
      transcriptObject = {};
    }
    return fixedTranscripts;
  }
  function replaceResult(includes, resultToReplace, downloadUrlBase) {
    const updatedResult = [];
    for (let i = 0; i < includes.length; i++) {
      const orderType = includes[i];
      if (existOrderType(orderType, resultToReplace, updatedResult)) {
        continue;
      }
      if (existOrderType(orderType, transcriptBase, updatedResult)) {
        continue;
      }
    }
    return fixTranscriptObjects(updatedResult, downloadUrlBase);
  }
  function existOrderType(orderType, searchArray, resultArray) {
    for (let i = 0; i < searchArray.length; i++) {
      if (orderType === searchArray[i].OrderType) {
        resultArray.push(searchArray[i]);
        return true;
      }
    }
  }
  return {
    replaceResult,
    MixValues,
    transcriptBase
  };
}

 })(window);